export default "__VITE_ASSET__DhuVuLdw__"